import React, { useContext, useEffect, useState, useRef } from 'react';
import { BsBullseye } from 'react-icons/bs';
import { CiBullhorn } from 'react-icons/ci';
import Alx1 from "../../assets/images/Alx_img1.png";
import { AboutCard1 } from '../../components/others/aboutcard1.components';
import SFBanner from '../../components/others/services-footer-banner.components';
import { useOrder } from '../../hooks/useAuth';
import { OrderContext } from '../../context/order.context';
import OpenSeadragon from 'openseadragon';
import DZIs from '../../components/dzi/dzis.components';
import DziGeneral from '../../components/dzi/dzi-general.componts';
import { Input } from '@material-tailwind/react';

const AboutPage = () => {
  const defaultValues = {
    title: 'Bridging Languages and Cultures',
    subtitle1: "Professional Translation, Interpretation and Legal Assistance.",
    subtitle2: "",
    cat1: 'Category One',
    cat1_desc: 'Short description from category one',
    cat2: 'Category Two',
    cat2_desc: 'Short description from category two',
    cat3: 'Category Three',
    cat3_desc: 'Short description from category three',
    about_img_url: 'https://img.freepik.com/premium-photo/portrait-smiling-female-baker-leaning-stack-bread_604472-24133.jpg',
    about_name: 'Patric Ola Yawson',
    about_title: 'Our Chief',
    about_text: "Discover the range of delights that Sandy's Cake offers. From decadent cakes to mouthwatering pastries, our creations are crafted with passion and precision. Whether for a special celebration or a sweet craving, Discover the range of delights that Sandy's Cake offers. From decadent cakes to mouthwatering pastries, our creations are crafted with passion and precision. Whether for a special celebration or a sweet craving, we have the perfect treat to make your day extraordinary. Explore our menu, book your custom order, and enjoy the finest baked goods made with love and the best ingredients.",
    more_sandy: "Discover the range of delights that Sandy's Cake offers. From decadent cakes to mouthwatering pastries, our creations are crafted with passion and precision. Whether for a special celebration or a sweet craving, we have the perfect treat to make your day extraordinary. Explore our menu, book your custom order, and enjoy the finest baked goods made with love and the best ingredients.",
    company: [],
    del: 'no',
    created_at: new Date(),
    updated_at: null,
  };

  const { curPage } = useContext(OrderContext);
  const [newCurPage, setNewCurPagae] = useState(defaultValues);
  const [imageUrl, setImageUrl] = useState(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    // Update page details when curPage changes
    if (curPage) {
      setNewCurPagae(curPage);
    }
  }, [curPage]);

  useEffect(() => {
    // Initialize OpenSeadragon after the component mounts if imageUrl is available
    if (imageUrl && viewerRef.current) {
      const viewer = OpenSeadragon({
        id: viewerRef.current.id,
        tileSources: {
          type: 'image',
          url: imageUrl, // Use the uploaded image
        },
        showNavigator: true, // Optional: display a mini-map
      });

      return () => {
        viewer.destroy(); // Cleanup when component unmounts
      };
    }
  }, [imageUrl]); // Re-run whenever imageUrl changes

  // Function to handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0]; // Get the uploaded file
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUrl(reader.result); // Set the image URL as the uploaded file
      };
      reader.readAsDataURL(file); // Read the file as a data URL (base64)
    }
  };

  return (
    <>
      <div className="general-container pt-32 pb-2 dzis ">

        <div className="cont my-5">
          <h1 className='font-semibold text-3xl pt-3'>OpenSeadragon Integration</h1>
          <p className='font-light mb-5 text-sm'>This is just a simply illustration in Next.Js</p>
                
          <div className="stl w-1/3">
            <Input type="file" accept="image/*" onChange={handleImageUpload} label='Image Upload' />
          </div>
        </div>

      </div>


      <div className="cl bg-black">
        { imageUrl ? 
        <div className="general-container pt-32 pb-2 dzis">
          {imageUrl && (
            <div
              id="openseadragon-viewer" // Unique ID for the container
              ref={viewerRef} // Attach the ref to the div
              style={{ width: '100%', height: '500px' }} // Set the size of the viewer
            ></div>
          )}
        </div>
        :
        <div className='general-container py-7'>
          <h1 className='font-normal text-lg pt-3 text-gray-400'>Image display goes here!</h1>
        </div>
        }
      </div>

      <div className="general-container services-div py-32 flex">
        <AboutCard1 pageDet={newCurPage} />
      </div>

      <SFBanner />
    </>
  );
};

export default AboutPage;
